import { RESET_ALL_ACCOUNT_STATE_DEPEN } from "../actions/commonActions";
import { FETCH_DYNAMIC_TABS_FAILURE, FETCH_DYNAMIC_TABS_REQUEST, FETCH_DYNAMIC_TABS_SUCCESS } from "../actions/dynamicTabActions";

  const initialState = {
    dynamicTabsloading: true,
    dynamicTabsData: [],
    dynamicTabsError: null,
  };
  
  const dynamicTabsReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_DYNAMIC_TABS_REQUEST:
        return { ...state, dynamicTabsloading: true , payload: action.payload};
      case FETCH_DYNAMIC_TABS_SUCCESS:
        return { ...state, dynamicTabsloading: false, dynamicTabsData: action.payload };
      case FETCH_DYNAMIC_TABS_FAILURE:
        return { ...state, dynamicTabsloading: false, dynamicTabsError: action.payload };       
      default:
        return state;
    }
  };
  
  export default dynamicTabsReducer;
  